var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "70", height: "70", viewBox: "0 0 70 70", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "cue/message.inline"
    ),
    React.createElement("path", { d: "M48 32H38V22h-6v10H22v6h10v10h6V38h10v-6zM35 60c-13.785 0-25-11.215-25-25s11.215-25 25-25 25 11.215 25 25-11.215 25-25 25zm26.997-11.926A29.823 29.823 0 0 0 65 35C65 18.458 51.542 5 35 5S5 18.458 5 35s13.458 30 30 30c4.684 0 9.12-1.08 13.074-3.003l-.003.002c6.732-2.853 11.232-1.415 13.929 0-1.415-2.696-2.853-7.196 0-13.93l-.003.005z", fill: "#FFF", fillRule: "evenodd" })
  );
});